// window.addEventListener('load', (event) => { 
addEventListener("DOMContentLoaded", (event) => {

 const menus       = document.querySelectorAll(".submenu");
 let btnID         = 0;

 function submenuToggle (submenu) {
  let arrow     = submenu.querySelector(".arrow");
  let dropdown  = submenu.querySelector(".submenuDropdownJS");
  let clickOff  = submenu.querySelector(".submenuClickOffJS");

  clickOff.tabIndex=("0");

  dropdown.classList.toggle("open");
  ariaExpandToggle(submenu);
  arrow.classList.toggle("active");
  clickOff.classList.toggle("open");
 }

 // For each submenu
 menus.forEach((menu) => {
  // Select open/close buttons
  let menuButtons = menu.querySelectorAll(".submenuButtonJS, .submenuClickOffJS");
 
  menuButtons.forEach((button) => {

   button.onclick = function(e) {
    submenuToggle(menu);
   };
  
   button.keypress = function(e) {
    let keyCode = e.keyCode;
  
    // Works with Enter or Space keys. See: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
    if (keyCode === 13 || keyCode === 32) {
     submenuToggle(menu);
    } 
   }
  });


 });
 

});